var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAward = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5C8.41015 1.5 5.5 4.41015 5.5 8C5.5 11.5899 8.41015 14.5 12 14.5C15.5899 14.5 18.5 11.5899 18.5 8C18.5 4.41015 15.5899 1.5 12 1.5ZM4.5 8C4.5 3.85786 7.85786 0.5 12 0.5C16.1421 0.5 19.5 3.85786 19.5 8C19.5 12.1421 16.1421 15.5 12 15.5C7.85786 15.5 4.5 12.1421 4.5 8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7242 13.3833C15.998 13.347 16.2493 13.5395 16.2857 13.8132L17.4957 22.9332C17.5209 23.1235 17.435 23.3115 17.2745 23.4169C17.114 23.5223 16.9074 23.5265 16.7427 23.4277L12 20.5821L7.25724 23.4277C7.09261 23.5265 6.88595 23.5223 6.72548 23.4169C6.56501 23.3114 6.47907 23.1235 6.50435 22.9331L7.71435 13.8231C7.75071 13.5494 8.00209 13.357 8.27583 13.3933C8.54957 13.4297 8.742 13.6811 8.70564 13.9548L7.63222 22.0365L11.7427 19.5702C11.9011 19.4752 12.0989 19.4752 12.2572 19.5702L16.3679 22.0366L15.2943 13.9447C15.258 13.671 15.4505 13.4196 15.7242 13.3833Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAward);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/award.968e6ae5e0df596410aa6cd096fb54d3.svg";